var map = {
	"./arbitration.pdf": "8085",
	"./arbitrationTax.pdf": "3a20",
	"./charter.pdf": "431d",
	"./charter_changes_2026-09-18.pdf": "019d",
	"./contractTemplate.pdf": "789d",
	"./documents/active/Договор возмездного оказания услуг.pdf": "887b",
	"./documents/active/Договор займа (образец).pdf": "b854",
	"./documents/active/Оферта ОАО Паритетбанк.pdf": "009a",
	"./documents/active/Политика обработки персональных данных.pdf": "efd9",
	"./documents/active/Положение о скоринге.pdf": "9db0",
	"./documents/active/Правила работы Сервиса.pdf": "990e",
	"./documents/archive/loan/07_11_2023.pdf": "bcbd",
	"./documents/archive/loan/12_06_2025.pdf": "9ae1",
	"./documents/archive/loan/14_06_2026.pdf": "3879",
	"./documents/archive/loan/21_03_2024.pdf": "22ce",
	"./documents/archive/loan/22_04_2026.pdf": "dfe4",
	"./documents/archive/loan/22_07_2025.pdf": "75d0",
	"./documents/archive/loan/30_04_2025.pdf": "8fa0",
	"./documents/archive/loan/31_10_2024.pdf": "ec9e",
	"./documents/archive/offer/03_04_2024.pdf": "2726",
	"./documents/archive/offer/10_04_2024.pdf": "2249",
	"./documents/archive/offer/26_02_2026.pdf": "c076",
	"./documents/archive/offer/27_02_2026.pdf": "4cb5",
	"./documents/archive/policy/14_06_2026.pdf": "9dc5",
	"./documents/archive/policy/23_02_2025.pdf": "45c7",
	"./documents/archive/policy/26_02_2024.pdf": "0335",
	"./documents/archive/policy/29_12_2025.pdf": "02e9",
	"./documents/archive/rules/03_12_2024.pdf": "218b",
	"./documents/archive/rules/05_03_2024.pdf": "ef0e",
	"./documents/archive/rules/07_04_2024.pdf": "fa8e",
	"./documents/archive/rules/07_10_2025.pdf": "fc68",
	"./documents/archive/rules/07_11_2023.pdf": "7d0f",
	"./documents/archive/rules/08_08_2024.pdf": "5d99",
	"./documents/archive/rules/12_11_2025.pdf": "3f30",
	"./documents/archive/rules/14_06_2026.pdf": "3844",
	"./documents/archive/rules/22_04_2026.pdf": "9c43",
	"./documents/archive/rules/23_05_2024.pdf": "ebb2",
	"./documents/archive/rules/28_02_2026.pdf": "f01e",
	"./documents/archive/rules/29_01_2025.pdf": "8871",
	"./documents/archive/rules/31_07_2025.pdf": "793c",
	"./documents/archive/rules/31_10_2024.pdf": "a2ad",
	"./documents/archive/scoring/03_03_2026.pdf": "58f5",
	"./documents/archive/scoring/28_08_2025.pdf": "62eb",
	"./documents/archive/service/03_12_2024.pdf": "03ef",
	"./documents/archive/service/05_03_2024.pdf": "48c5",
	"./documents/archive/service/07_04_2024.pdf": "59e1",
	"./documents/archive/service/07_10_2025.pdf": "309c",
	"./documents/archive/service/08_08_2024.pdf": "b034",
	"./documents/archive/service/11_08_2026.pdf": "8915",
	"./documents/archive/service/12_11_2025.pdf": "8cce",
	"./documents/archive/service/14_06_2026.pdf": "c483",
	"./documents/archive/service/23_05_2024.pdf": "2a76",
	"./documents/archive/service/28_02_2026.pdf": "7b53",
	"./documents/archive/service/31_10_2024.pdf": "6091",
	"./gosreg.pdf": "359d",
	"./htp.pdf": "43ec",
	"./location.pdf": "1f94",
	"./location_before_1.pdf": "d39b",
	"./location_before_2.pdf": "605a",
	"./location_before_3.pdf": "c940",
	"./newContractTemplate.pdf": "03e7",
	"./newRules.pdf": "1000",
	"./newServiceContract.pdf": "cb57",
	"./paritetOffer.pdf": "a4e70",
	"./personalDataAgreement.pdf": "f08b",
	"./personalDataProcessing.pdf": "585c",
	"./registryInclude.pdf": "b822",
	"./report_2022.pdf": "77c0",
	"./report_2023.pdf": "d53f",
	"./report_2024.pdf": "d075",
	"./report_2025.pdf": "e665",
	"./rules.pdf": "88d6",
	"./scoring.pdf": "7909",
	"./serviceContract.pdf": "63e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9873";